var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"vouchers-list-item-empty"},[_vm._v("\n  There are no attempts associated with this voucher.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }